import shape from "../../assets/img/shapes/pencil-shape-01.webp";


const PencilShape01 = () => {

    return (
        <div className="rmdr-pencil-shape-01">
            <img src={shape} alt="rmdr-pencil-shape-01" loading="lazy" width={320} height={265} />
        </div>
    )

}

export default PencilShape01;
